import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Stack,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import logo from "../../assets/logo.png";
import { Call } from "@mui/icons-material";

export const CustomDemos = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [leadName, setLeadName] = useState("");
  const [country, setCountry] = useState("ca");
  const [typeOfCall, setTypeOfCall] = useState("normal");
  const [selectedAgent, setSelectedAgent] = useState("agent_5b0931be2b26762ae3a06ec0f7");
  
  // IUL Facebook Agent fields
  const [humanAgentName, setHumanAgentName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [humanAgentNumber, setHumanAgentNumber] = useState("");
  const [humanAgentCountry, setHumanAgentCountry] = useState("ca");
  
  // Northgate Financial Lead Qualifier fields
  const [leadEmail, setLeadEmail] = useState("");
  const [facebookAdTagline, setFacebookAdTagline] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    const fromNumber = "17273395810";
    const agentID = selectedAgent;
    const baseUrl =
      "https://initiateretellcall-655075094783.us-central1.run.app";

    let url = `${baseUrl}?to_number=${phoneNumber}&from_number=${fromNumber}&agent_id=${agentID}`;

         // Add fields based on selected agent
     if (agentID === "agent_5b0931be2b26762ae3a06ec0f7") {
       // IUL Facebook Agent
       url += `&lead_first_name=${encodeURIComponent(leadName)}&human_agent_first_name=${encodeURIComponent(humanAgentName)}&human_agent_company_name=${encodeURIComponent(companyName)}&human_agent_number=${encodeURIComponent(humanAgentNumber)}`;
     } else if (agentID === "agent_f0b0e63c333951564dc3413102") {
      // Northgate Financial Lead Qualifier
      url += `&lead_first_name=${encodeURIComponent(leadName)}&lead_email=${encodeURIComponent(leadEmail)}&facebook_ad_tagline=${encodeURIComponent(facebookAdTagline)}&lead_state=AL`;
    }

    console.log(`Starting call with URL ${url}`);

    await axios
      .request(url, {
        method: "GET",
        headers: {
          "ngrok-skip-browser-warning": "69420",
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => console.log(res));
  };

  return (
    <div className="full-page-background">
      <Grid item xs={12} md={7}>
        <Container className="App" maxWidth="sm">
          <img src={logo} className="App-logo" alt="logo" />
          <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <h1 style={{
              color: '#FFFFFF',
              fontSize: '2rem',
              fontWeight: 'bold',
              margin: '1rem',
            }}>
              Custom Demos
            </h1>
            <div style={{
              height: '4px',
              width: '100px',
              background: 'linear-gradient(90deg, #a0b8ff, #8a2be2)',
              margin: '0 auto',
              borderRadius: '2px'
            }}></div>
          </div>
          <h3 style={{
            textAlign: 'center',
            color: '#d0d0d0',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '1.6',
            maxWidth: '500px',
            margin: '0 auto 1.5rem auto'
          }}>
            Select an agent and fill in the required fields for your demo call
          </h3>
          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>

              <>
                <Select
                  value={selectedAgent}
                  onChange={(e) => {
                    setSelectedAgent(e.target.value);
                  }}
                  required
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "4px",
                    textAlign: "left",
                  }}
                >
                  <MenuItem value="agent_5b0931be2b26762ae3a06ec0f7">
                    IUL Facebook
                  </MenuItem>
                  <MenuItem value="agent_f0b0e63c333951564dc3413102">
                    Northgate Financial Lead Qualifier
                  </MenuItem>
                </Select>
                <TextField
                  label="Lead Name"
                  variant="filled"
                  sx={{
                    color: "white",
                    backgroundColor: "white",
                    borderRadius: "4px",
                  }}
                  fullWidth
                  value={leadName}
                  onChange={(e) => setLeadName(e.target.value)}
                  required
                />

                                 {/* IUL Facebook Agent Fields */}
                 {selectedAgent === "agent_5b0931be2b26762ae3a06ec0f7" && (
                   <>
                     <TextField
                       label="Human Agent Name"
                       variant="filled"
                       sx={{
                         color: "white",
                         backgroundColor: "white",
                         borderRadius: "4px",
                       }}
                       fullWidth
                       value={humanAgentName}
                       onChange={(e) => setHumanAgentName(e.target.value)}
                       required
                     />
                     <TextField
                       label="Company Name"
                       variant="filled"
                       sx={{
                         color: "white",
                         backgroundColor: "white",
                         borderRadius: "4px",
                       }}
                       fullWidth
                       value={companyName}
                       onChange={(e) => setCompanyName(e.target.value)}
                       required
                     />
                   </>
                 )}

                {/* Northgate Financial Lead Qualifier Fields */}
                {selectedAgent === "agent_f0b0e63c333951564dc3413102" && (
                  <>
                    <TextField
                      label="Lead Email"
                      variant="filled"
                      sx={{
                        color: "white",
                        backgroundColor: "white",
                        borderRadius: "4px",
                      }}
                      fullWidth
                      value={leadEmail}
                      onChange={(e) => setLeadEmail(e.target.value)}
                      required
                    />
                    <TextField
                      label="Facebook Ad Tagline"
                      variant="filled"
                      sx={{
                        color: "white",
                        backgroundColor: "white",
                        borderRadius: "4px",
                      }}
                      fullWidth
                      value={facebookAdTagline}
                      onChange={(e) => setFacebookAdTagline(e.target.value)}
                      required
                    />
                  </>
                                 )}
               </>
               
                               {/* Live Transfer Number Field - Only for IUL Facebook Agent */}
                {selectedAgent === "agent_5b0931be2b26762ae3a06ec0f7" && (
                  <>
                    <h3 style={{
                      color: '#FFFFFF',
                      fontSize: '1rem',
                      fontWeight: 'bold',
                      margin: '16px 0 0 0',
                      textAlign: 'left'
                    }}>
                      Live Transfer Number
                    </h3>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
                      <FormControl sx={{ minWidth: { xs: '100%', sm: '150px' } }}>
                        <Select
                          value={humanAgentCountry}
                          onChange={(e) => setHumanAgentCountry(e.target.value)}
                          sx={{
                            backgroundColor: "white",
                            borderRadius: "4px",
                            height: "56px",
                          }}
                          required
                        >
                          <MenuItem value="ca">🇨🇦 (+1)</MenuItem>
                          <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                          <MenuItem value="gb">🇬🇧 (+44)</MenuItem>
                        </Select>
                      </FormControl>
                      <Box sx={{ flex: { sm: '1' }, width: '100%' }}>
                        <PhoneInput
                          country={humanAgentCountry}
                          value={humanAgentNumber}
                          disableDropdown={true}
                          disableCountryGuess={true}
                          onChange={setHumanAgentNumber}
                          enableLongNumbers={true}
                          placeholder="Enter live transfer phone number"
                          inputStyle={{
                            width: "100%",
                            textAlign: "center",
                            fontSize: "16px",
                            height: "56px",
                            borderRadius: "4px",
                            border: "1px solid #ced4da",
                          }}
                          required
                        />
                      </Box>
                    </Stack>
                  </>
                )}

                {/* Your Number Field */}
                <h3 style={{
                  color: '#FFFFFF',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  margin: '16px 0 0 0',
                  textAlign: 'left'
                }}>
                  Your Number
                </h3>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
                  <FormControl sx={{ minWidth: { xs: '100%', sm: '150px' } }}>
                    <Select
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                      sx={{
                        backgroundColor: "white",
                        borderRadius: "4px",
                        height: "56px",
                      }}
                      required
                    >
                      <MenuItem value="ca">🇨🇦 (+1)</MenuItem>
                      <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                      <MenuItem value="gb">🇬🇧 (+44)</MenuItem>
                    </Select>
                  </FormControl>
                  <Box sx={{ flex: { sm: '1' }, width: '100%' }}>
                    <PhoneInput
                      country={country}
                      value={phoneNumber}
                      disableDropdown={true}
                      disableCountryGuess={true}
                      onChange={setPhoneNumber}
                      enableLongNumbers={true}
                      placeholder="Enter your phone number"
                      inputStyle={{
                        width: "100%",
                        textAlign: "center",
                        fontSize: "16px",
                        height: "56px",
                        borderRadius: "4px",
                        border: "1px solid #ced4da",
                      }}
                      required
                    />
                  </Box>
                </Stack>
              <Button
                className="callBtn"
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  background: 'linear-gradient(45deg, #1976d2 30%, #2196f3 90%)',
                  boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
                  color: 'white',
                  height: '56px',
                  padding: '0 30px',
                  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 10px 4px rgba(33, 203, 243, .3)',
                    background: 'linear-gradient(45deg, #1769aa 30%, #1e88e5 90%)',
                  },
                }}
              >
                <h2 style={{ fontSize: "16px", fontWeight: "bold" }}>
                  Click here to receive the DEMO call
                </h2>
                <div style={{ width: "20px" }} />
                <Call className="callIcon" />
              </Button>
              <div style={{
                // Bubble Container Styles
                backgroundColor: '#eaf2fa',
                padding: '16px',
                borderRadius: '8px',
                border: '1px solid #d0e0f0',

                // Flexbox for alignment
                display: 'flex',
                alignItems: 'center', // Vertically centers the icon and text
                gap: '12px'           // Adds space between the icon and text
              }}>
                {/* Icon */}
                <span style={{ fontSize: '24px' }}>ℹ️</span>

                {/* Text Content */}
                <p style={{
                  margin: 0, // Resets default paragraph margin
                  textAlign: 'left',
                  color: '#333',
                  lineHeight: '1.5',
                  fontSize: '14px'
                }}>
                  After clicking to receive the DEMO call, you will receive a
                  call from the following phone number:
                  <b style={{ color: '#005a9c' }}> +1(727)339-5810</b>
                </p>
              </div>
            </Stack>
          </form>
        </Container>
      </Grid>
    </div>
  );
};
